module.exports = __webpack_public_path__ + "img/hr-heated-corner-up-left-5.4a06defe.png";